var _p, _CloseSmall;
import { useRef } from 'react';
import CloseSmall from '@crehana/compass.icons.outline/CloseSmall';
import { Skeleton } from '@crehana/compass.ui/v2';
import { useClickAway } from '@crehana/react-hooks';
import { clsx } from 'clsx';
import { CollapsePermissionsResume } from "./CollapsePermissions";
import { usePermissionsDetail } from "./hooks";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var PermissionDetailLoad = function PermissionDetailLoad(_ref) {
  var organizationSlug = _ref.organizationSlug;
  var _usePermissionsDetail = usePermissionsDetail({
      organizationSlug: organizationSlug
    }),
    isLoading = _usePermissionsDetail.isLoading,
    permissionModules = _usePermissionsDetail.permissionModules;
  return /*#__PURE__*/_jsx("div", {
    className: "tw-overflow-auto tw-max-h-[70vh]",
    children: isLoading ? Array.from({
      length: 5
    }).map(function () {
      return /*#__PURE__*/_jsx(Skeleton, {
        className: "tw-w-full tw-h-6.4 tw-mb-1.6"
      }, Math.random());
    }) : permissionModules === null || permissionModules === void 0 ? void 0 : permissionModules.map(function (module, i) {
      return /*#__PURE__*/_jsx(CollapsePermissionsResume, {
        name: module.name,
        permissions: module.permissions,
        moduleKey: i
      }, module.id);
    })
  });
};
export var PermissionsDetail = function PermissionsDetail(_ref2) {
  var close = _ref2.close,
    isOpen = _ref2.isOpen,
    organizationSlug = _ref2.organizationSlug;
  var userPermissionsRef = useRef(null);
  useClickAway(userPermissionsRef, close);

  // biome-ignore lint/style/useBlockStatements: single-line early return
  if (!isOpen) return null;
  return /*#__PURE__*/_jsx("div", {
    ref: userPermissionsRef,
    className: "tw-w-full tw-h-screen tw-absolute tw-top-0 tw-flex tw-items-center tw-justify-center",
    children: /*#__PURE__*/_jsx("div", {
      className: clsx(isOpen && 'tw-opacity-100 tw-pointer-events-auto', 'tw-text-left tw-top-full tw-transition-opacity tw-rounded-1 tw-z-dialog tw-opacity-0 tw-pointer-events-none tw-bg-neutral-light-100 tw-shadow-02'),
      children: /*#__PURE__*/_jsxs("div", {
        className: "tw-rounded-[10px] tw-p-2.4 tw-w-[712px] tw-max-w-[90vw]",
        children: [/*#__PURE__*/_jsxs("div", {
          className: "tw-flex tw-justify-between tw-border-b tw-border-solid tw-border-neutral-light-400 tw-pb-2 tw-mb-2.4",
          children: [_p || (_p = /*#__PURE__*/_jsx("p", {
            className: "tw-font-subtitle4",
            children: "Permisos"
          })), /*#__PURE__*/_jsx("button", {
            type: "button",
            onClick: close,
            children: _CloseSmall || (_CloseSmall = /*#__PURE__*/_jsx(CloseSmall, {
              className: "tw-text-neutral-light-700",
              size: 24
            }))
          })]
        }), /*#__PURE__*/_jsx(PermissionDetailLoad, {
          organizationSlug: organizationSlug
        })]
      })
    })
  });
};